export default [
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('@/views/extensions/acl/AccessControl.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/master/product/list',
    name: 'master-product-list',
    component: () => import('@/views/master-data/product/product-list/ProductList.vue'),
    meta: {
      pageTitle: 'Produk',
      breadcrumb: [
        {
          text: 'Produk',
          active: true,
        },
      ],
    },
  },
]
